export default __webpack_public_path__ + "static/media/time-icon.cdee932e.svg";